import { deepCopy } from "@perxis-auto/shared/lib/lib/copy";
import { instanceOfReference } from "@perxis-auto/shared/lib/lib/instanceOf";
import { COLLECTION_IDS } from "../../../../shared/config/collections.js";
import "history";
import { PerxisService } from "../../../../shared/services/perxis/index.js";
import "../../../../shared/store/config/middleware/index.js";
import "../../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../../shared/store/config/model/selectors/selectFilterGrid.js";
import { selectFilterGridItems } from "../../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../../shared/store/config/model/selectors/selectModels.js";
import { selectSlice } from "../../../../shared/store/config/model/selectors/selectSlice.js";
import "../../../../shared/store/config/model/selectors/selectSort.js";
import "../../../../shared/store/config/model/selectors/selectTags.js";
import "../../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../../shared/store/config/model/slice.js";
import { getExtendedItems } from "../../../../shared/store/reference/lib/getExtendedItems.js";
import "@perxis-auto/shared";
import "../../../../shared/store/reference/model/index.js";
import { ConstructorWidgetEnum } from "../../../../shared/types/constructor/widget.js";
import "../../model/middleware/index.js";
import "../../model/selectors/selectAllFilterValues.js";
import "../../model/selectors/selectAllFilterValuesParameters.js";
import "../../model/selectors/selectAvailableFilterValues.js";
import "../../model/selectors/selectAvailableFilterValuesParameters.js";
import "../../model/selectors/selectAvailableFilterValuesQueries.js";
import "../../model/selectors/selectDependentFilterKeysByKey.js";
import { selectFilterImmutableQueries } from "../../model/selectors/selectFilterImmutableQueries.js";
import "../../model/selectors/selectFilterImmutableValues.js";
import "../../model/selectors/selectFilterItemByKey.js";
import "../../model/selectors/selectFilterItems.js";
import "../../model/selectors/selectFilterValuesFields.js";
import "../../model/selectors/selectGroupedFilterItemByKey.js";
import "../../model/selectors/selectIsFilterValuesMissing.js";
import { createFilterQuery } from "./queries/createFilterQuery.js";
const MODEL_MEDIA_FILE_KEY = "model_cars";
const MODEL_PARAMS_POSITIONING_ID = "positioning";
const fetchFilterValuesWithExtraData = async (queryApi, rawFilterValuesItem) => {
  var _a, _b;
  const state = queryApi.getState();
  const config = selectSlice(state);
  const filterGridItems = selectFilterGridItems(state);
  const immutableQueries = selectFilterImmutableQueries(state);
  const { itemsClient } = PerxisService.getInstance();
  const rawFilterValuesWithExtraDataItem = deepCopy(rawFilterValuesItem);
  const { data } = rawFilterValuesWithExtraDataItem;
  const promises = [];
  for (const [key, values] of Object.entries(data)) {
    const filterGridItem = filterGridItems.find((item) => item.key === key);
    if (!filterGridItem) {
      continue;
    }
    switch (filterGridItem.type) {
      // Для фильтра по моделям необходимо получить
      // маркетинговую информацию и минимальную цену (при включенной настройке)
      case ConstructorWidgetEnum.FilterModels: {
        if (!Array.isArray(values) || !values.length) {
          break;
        }
        if (!instanceOfReference(values[0])) {
          break;
        }
        const filterModelValues = values;
        const marketingInfoForModelsPromise = itemsClient.findPublished({
          spaceId: config.spaceId,
          envId: config.envId,
          collectionId: COLLECTION_IDS.vehiclesMarketingInfo,
          options: {
            options: {
              sort: ["-position"],
              fields: ["for", "media", "params", "priceMin", "description"]
            }
          },
          filter: {
            q: [
              `for.collection_id == "${COLLECTION_IDS.vehiclesModels}" && for.id in ["${filterModelValues.map((item) => item.id).join(`", "`)}"]`
            ]
          }
        }).then((response) => {
          const marketingInfoItems = response.items;
          const marketingInfoForModelsMap = /* @__PURE__ */ new Map();
          for (const marketingInfoItem of marketingInfoItems) {
            const { for: references } = marketingInfoItem.data;
            const modelReference = references == null ? void 0 : references.find((ref) => ref.collection_id === COLLECTION_IDS.vehiclesModels);
            if (!modelReference || marketingInfoForModelsMap.get(modelReference.id)) {
              continue;
            }
            marketingInfoForModelsMap.set(modelReference.id, marketingInfoItem);
          }
          return getExtendedItems(
            queryApi,
            Array.from(marketingInfoForModelsMap.values())
          );
        }).then((extendedMarketingInfoItems) => {
          const marketingInfoForModelsMap = /* @__PURE__ */ new Map();
          for (const extendedMarketingInfoItem of extendedMarketingInfoItems) {
            const { for: references } = extendedMarketingInfoItem.data;
            const modelReference = references == null ? void 0 : references.find((ref) => ref.collection_id === COLLECTION_IDS.vehiclesModels);
            if (!modelReference) {
              continue;
            }
            marketingInfoForModelsMap.set(modelReference.id, extendedMarketingInfoItem);
          }
          return marketingInfoForModelsMap;
        }).then((marketingInfoForModelsMap) => {
          var _a2, _b2, _c;
          for (const filterModelValue of filterModelValues) {
            const marketingInfoForModel = marketingInfoForModelsMap.get(filterModelValue.id);
            if (!marketingInfoForModel) {
              continue;
            }
            const { data: marketingInfoForModelData } = marketingInfoForModel;
            const marketingPositioning = (_a2 = marketingInfoForModelData == null ? void 0 : marketingInfoForModelData.params) == null ? void 0 : _a2.find(
              (param) => param.id === MODEL_PARAMS_POSITIONING_ID
            );
            const modelMarketingMedia = (_b2 = marketingInfoForModelData.media) == null ? void 0 : _b2.flatMap(({ additional, ...media }) => {
              return (additional == null ? void 0 : additional.map(({ key: key2, file }) => ({
                ...media,
                id: key2,
                file
              }))) || [];
            }).find((media) => {
              if (!(media == null ? void 0 : media.file)) {
                return false;
              }
              return media.id === MODEL_MEDIA_FILE_KEY;
            });
            const marketingMedia = modelMarketingMedia ?? ((_c = marketingInfoForModelData.media) == null ? void 0 : _c[0]);
            Object.assign(filterModelValue, {
              marketingDescription: marketingInfoForModelData == null ? void 0 : marketingInfoForModelData.description,
              marketingPrice: marketingInfoForModelData == null ? void 0 : marketingInfoForModelData.priceMin,
              marketingPositioning: marketingPositioning == null ? void 0 : marketingPositioning.value,
              marketingMedia
            });
          }
        });
        promises.push(marketingInfoForModelsPromise);
        if ((_a = config.models) == null ? void 0 : _a.useAggregatePrice) {
          for (const filterModelValue of filterModelValues) {
            const aggregatePricePromise = itemsClient.aggregatePublished({
              spaceId: config.spaceId,
              envId: config.envId,
              collectionId: COLLECTION_IDS.vehiclesVehicles,
              options: {
                fields: {
                  price: "min(price)",
                  minPrice: "min(minPrice)"
                }
              },
              filter: {
                q: [createFilterQuery(filterGridItem, values, [filterModelValue.id]) || "", ...immutableQueries.q]
              }
            }).then((aggregatePriceResponse) => {
              const { result } = aggregatePriceResponse;
              const price = (result == null ? void 0 : result.minPrice) || (result == null ? void 0 : result.price) || 0;
              Object.assign(filterModelValue, {
                price
              });
            });
            promises.push(aggregatePricePromise);
          }
        }
        if ((_b = config.models) == null ? void 0 : _b.useGroupingByBrand) {
          const marketingInfoForBrandsPromise = itemsClient.findPublished({
            spaceId: config.spaceId,
            envId: config.envId,
            collectionId: COLLECTION_IDS.vehiclesMarketingInfo,
            options: {
              options: {
                sort: ["-position"],
                fields: ["for", "media", "params"]
              }
            },
            filter: {
              q: [
                `for.collection_id == "${COLLECTION_IDS.vehiclesBrands}" && for.id in ["${filterModelValues.map((v) => v.brand.id).join(`", "`)}"]`
              ]
            }
          }).then((marketingInfoResponse) => {
            const marketingInfoItems = marketingInfoResponse.items;
            const marketingInfoForBrandsMap = /* @__PURE__ */ new Map();
            for (const marketingInfoItem of marketingInfoItems) {
              const { for: references } = marketingInfoItem.data;
              const brandReference = references == null ? void 0 : references.find((ref) => ref.collection_id === COLLECTION_IDS.vehiclesBrands);
              if (!brandReference || marketingInfoForBrandsMap.get(brandReference.id)) {
                continue;
              }
              marketingInfoForBrandsMap.set(brandReference.id, marketingInfoItem);
            }
            return getExtendedItems(
              queryApi,
              Array.from(marketingInfoForBrandsMap.values())
            );
          }).then((extendedMarketingInfoItems) => {
            const extMarketingInfoForBrandsMap = /* @__PURE__ */ new Map();
            for (const extendedMarketingInfoItem of extendedMarketingInfoItems) {
              const { for: references } = extendedMarketingInfoItem.data;
              const brandReference = references == null ? void 0 : references.find((ref) => ref.collection_id === COLLECTION_IDS.vehiclesBrands);
              if (!brandReference) {
                continue;
              }
              extMarketingInfoForBrandsMap.set(brandReference.id, extendedMarketingInfoItem);
            }
            return extMarketingInfoForBrandsMap;
          }).then((marketingInfoForBrandsMap) => {
            var _a2, _b2;
            for (const filterModelValue of filterModelValues) {
              const marketingInfoForBrand = marketingInfoForBrandsMap.get(filterModelValue.brand.id);
              if (!marketingInfoForBrand) {
                continue;
              }
              const { data: marketingInfoForBrandData } = marketingInfoForBrand;
              const brandPositioning = (_a2 = marketingInfoForBrandData == null ? void 0 : marketingInfoForBrandData.params) == null ? void 0 : _a2.find(
                (param) => param.id === MODEL_PARAMS_POSITIONING_ID
              );
              const brandMedia = (_b2 = marketingInfoForBrandData.media) == null ? void 0 : _b2.flatMap(({ additional, ...media }) => {
                return (additional == null ? void 0 : additional.map(({ key: key2, file }) => ({
                  ...media,
                  key: key2,
                  file
                }))) || [];
              }).find((media) => {
                if (!(media == null ? void 0 : media.file)) {
                  return false;
                }
                return media.key === MODEL_MEDIA_FILE_KEY;
              });
              Object.assign(filterModelValue, {
                brandPositioning: brandPositioning == null ? void 0 : brandPositioning.value,
                brandMedia
              });
            }
          });
          const extBrandsPromise = getExtendedItems(queryApi, [
            {
              ...rawFilterValuesItem,
              data: {
                brand: filterModelValues.map((v) => v.brand)
              }
            }
          ]).then(([brandItem]) => {
            const brands = brandItem.data.brand || [];
            for (const filterModelValue of filterModelValues) {
              const brand = brands.find((b) => b.id === filterModelValue.brand.id);
              Object.assign(filterModelValue, {
                extendedBrand: brand
              });
            }
          });
          promises.push(marketingInfoForBrandsPromise, extBrandsPromise);
        }
        break;
      }
    }
  }
  await Promise.all(promises);
  return rawFilterValuesWithExtraDataItem;
};
export {
  fetchFilterValuesWithExtraData
};
